import { tl } from '../i18n/t';

// Prüfregeln rund um Firmenangaben (Registrierung, weitere Firma, Prüfen in der Kanzlei, Stammdaten).
// Der Server prüft dasselbe noch einmal verbindlich.
// Rechtsformen bleiben als Wert Deutsch; die Auswahl (SelectField) zeigt sie übersetzt, wo es eine Übersetzung gibt.

export const LEGAL_FORMS = [
  'GmbH',
  'UG (haftungsbeschränkt)',
  'GmbH & Co. KG',
  'KG',
  'OHG',
  'GbR',
  'PartG',
  'AG',
  'e.K.',
  'Einzelunternehmen',
  'Freiberufler',
  'Verein (e.V.)',
  'Sonstige',
] as const;

// Deutsch wie vom Server; übersetzt wird beim Anzeigen mit t(IBAN_WRONG)
export const IBAN_WRONG = tl('Die IBAN scheint nicht zu stimmen. Bitte prüfen Sie sie noch einmal.');

export function normalizeIban(s: string): string {
  return s.replace(/\s+/g, '').toUpperCase();
}

// „DE89 3704 0044 0532 0130 00“
export function formatIban(s: string): string {
  return normalizeIban(s).replace(/(.{4})/g, '$1 ').trim();
}

// IBAN mit Prüfziffer (mod 97), damit Tippfehler nicht erst beim Lastschrifteinzug auffallen.
export function ibanOk(input: string): boolean {
  const s = normalizeIban(input);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s)) return false;
  if (s.startsWith('DE') && s.length !== 22) return false;
  const t = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (ch) => String(ch.charCodeAt(0) - 55));
  let r = 0;
  for (const digit of t) r = (r * 10 + Number(digit)) % 97;
  return r === 1;
}

export const zipOk = (s: string) => /^\d{5}$/.test(s.trim());
export const emailOk = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim());

// Rechtsform aus dem Firmennamen raten (nur für den gelben Hinweis „passt nicht zum Namen“)
export function legalFormGuess(name: string): string {
  if (/GmbH & Co/i.test(name)) return 'GmbH & Co. KG';
  if (/\bUG\b/i.test(name)) return 'UG (haftungsbeschränkt)';
  if (/GmbH/i.test(name)) return 'GmbH';
  if (/\bAG\b/.test(name)) return 'AG';
  if (/\bGbR\b/i.test(name)) return 'GbR';
  if (/\bKG\b/i.test(name)) return 'KG';
  if (/e\.K\./.test(name)) return 'e.K.';
  return 'Einzelunternehmen';
}

// Gelbe Hinweise beim Prüfen und in den Stammdaten. Sie blockieren nichts. (Nur in der Kanzlei, darum Deutsch.)
export function warnings(c: { name: string; legalForm: string; country: string; zip: string; iban: string }) {
  const guess = legalFormGuess(c.name);
  return {
    legalForm: guess !== 'Einzelunternehmen' && guess !== c.legalForm ? 'passt nicht zum Namen' : null,
    zip: c.country !== 'AE' && !zipOk(c.zip) ? 'PLZ fehlt oder falsch' : null,
    iban: c.iban && !ibanOk(c.iban) ? 'IBAN scheint nicht zu stimmen' : null,
  };
}
